import {
  LinkVerticalEllipsis,
  CategoryVerticalEllipsis,
  SubCategoryVerticalEllipsis,
} from 'components/common/linkLibraryCells';

export const LINKS = 'links';
export const SECOND_LEVEL_CATEGORY = 2;

export const LINK_LIBRARY_TYPES = {
  CATEGORY: 'category',
  SUBCATEGORY: 'subCategory',
  LINK: 'link',
};

export const TYPE_ATTRIBUTES = {
  [LINK_LIBRARY_TYPES.CATEGORY]: {
    headerClass: () => 'rst__row-header',
    titleClass: 'rst__row-titleCategory',
    html: (data, handleRowClick, popoverId, setActivePopoverId) => {
      return (
        <CategoryVerticalEllipsis
          selectedCategory={data}
          handleRowClick={handleRowClick}
          popoverId={popoverId}
          setActivePopoverId={setActivePopoverId}
        />
      );
    },
  },
  [LINK_LIBRARY_TYPES.SUBCATEGORY]: {
    headerClass: (level) => `rst__row-category--header paddingNested-${level} `,
    titleClass: 'rst__row-category',
    html: (data, _handleRowClick, popoverId, setActivePopoverId) => {
      return (
        <SubCategoryVerticalEllipsis
          selectedCategory={data}
          popoverId={popoverId}
          setActivePopoverId={setActivePopoverId}
        />
      );
    },
  },
  [LINK_LIBRARY_TYPES.LINK]: {
    headerClass: () => 'rst__row-header',
    titleClass: 'rst__row-subCategory',
    html: (data, _handleRowClick, popoverId, setActivePopoverId) => {
      return <LinkVerticalEllipsis selectedLink={data} popoverId={popoverId} setActivePopoverId={setActivePopoverId} />;
    },
  },
};
